import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'uxd-design-system-components';
import PlanningTopicsCardProps from '../../types/components/PlanningTopicsCardProps';
import './PlanningTopicsCard.scss';

const PlanningTopicsCard = forwardRef<
  HTMLInputElement,
  PlanningTopicsCardProps
>(
  (
    {
      topicTitle,
      topicStatement,
      topicTitleId,
      checked,
      color,
      handleCardClick,
    },
    ref
  ) => (
    <div
      className="planning-topics-card"
      data-testid={`planningTopicsCard-${topicTitleId}`}
    >
      <span
        className="planning-topics-header"
        style={{ backgroundColor: color }}
        data-testid="planningTopicsHeader"
      />
      <div className="planning-topics-title">
        <Checkbox
          checked={checked}
          id={`checkbox-${topicTitleId}`}
          name={`checkbox-${topicTitleId}`}
          label=""
          hideLabel
          onChange={() => handleCardClick(topicTitleId)}
          aria-describedby={`${topicTitle}-statement`}
          inputRef={ref && typeof ref !== 'function' ? ref : undefined}
        />
        {topicTitle}
      </div>
      <div className="planning-topics-statement" id={`${topicTitle}-statement`}>
        {topicStatement}
      </div>
    </div>
  )
);

PlanningTopicsCard.displayName = 'PlanningTopicsCard';

PlanningTopicsCard.propTypes = {
  topicTitle: PropTypes.string.isRequired,
  topicStatement: PropTypes.string.isRequired,
  topicTitleId: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  handleCardClick: PropTypes.func.isRequired,
};

export default PlanningTopicsCard;
